/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from 'react';

interface Props {
  button_text: string;
  onclick: any;
  button_class: string;
  hittype: string;
  event_category: string;
  event_action: string;
  event_label: string;
  data_js?: string;
}
const WaEventOroLink: FC<Props> = (props) => {
  const {
    button_text,
    onclick,
    button_class,
    hittype,
    event_category,
    event_action,
    event_label,
    data_js,
  } = props;

  if (data_js) {
    return (
      <a
        onClick={onclick}
        className={button_class}
        data-wa-hittype={hittype}
        data-wa-event-category={event_category}
        data-wa-event-action={event_action}
        data-wa-event-label={event_label}
        data-js={data_js}
      >
        {button_text}
      </a>
    );
  }
  return (
    <a
      onClick={(e) => onclick(e)}
      className={button_class}
      data-wa-hittype={hittype}
      data-wa-event-category={event_category}
      data-wa-event-action={event_action}
      data-wa-event-label={event_label}
    >
      {button_text}
    </a>
  );
};
export default WaEventOroLink;
